import { useId } from '../../../core/hooks/useId.js';
import { WithChildren } from '../../../core/types/with-children.js';
import { XYChartIdContext } from '../context/XYChartId.context.js';

export const XYChartIdProvider = ({ children }: WithChildren) => {
  const chartId = useId();

  return (
    <XYChartIdContext.Provider value={chartId}>
      {children}
    </XYChartIdContext.Provider>
  );
};
